import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María', 'Sofía', 'Camila', 'Valentina', 'Isabella', 'Gabriela', 'Daniela', 'Lucía', 'Fernanda', 'Valeria', 'Martina', 'Sara', 'Elena', 'Paula', 'Victoria'];
const CITIES = ['Miami', 'Los Angeles', 'Houston', 'New York', 'Chicago', 'Phoenix', 'San Antonio', 'San Diego', 'Dallas', 'San Jose', 'Austin', 'Jacksonville', 'Fort Worth', 'Columbus', 'Charlotte'];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/8FQoMjFa1ntpi54p3AAZQC/heylloyd-image-1772074446810.jpg';
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before starting the loop
    const startTimeout = setTimeout(() => {
      runCycle();
    }, 1000);
    const runCycle = () => {
      // Pick random data
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      // Show notification
      setIsVisible(true);
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next cycle after 9 seconds of being hidden
        setTimeout(runCycle, 9000);
      }, 3000);
    };
    return () => clearTimeout(startTimeout);
  }, []);
  return <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-center pointer-events-none md:hidden px-4" data-id="element-153">
      <AnimatePresence data-id="element-154">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0,
        scale: 0.9
      }} animate={{
        y: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        y: 100,
        opacity: 0,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="flex items-center gap-3 bg-white/90 backdrop-blur-xl p-3 rounded-2xl shadow-2xl border border-white/20 max-w-sm w-full pointer-events-auto" data-id="element-155">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-156">
              <img src={PRODUCT_IMAGE} alt="Product" className="w-10 h-10 rounded-lg object-cover shadow-sm" data-id="element-157" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-158">
              <p className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-159">
                Ahora mismo
              </p>
              <p className="text-sm text-slate-900 leading-tight" data-id="element-160">
                <span className="font-semibold" data-id="element-161">{currentData.name}</span> de{' '}
                {currentData.city} compró{' '}
                <span className="font-semibold" data-id="element-162">Método Caja De Oro</span> por{' '}
                <span className="font-semibold text-green-600" data-id="element-163">$6.39</span>
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}